import {api} from './api';

export const orderMessagesApi = api.injectEndpoints({
	endpoints: (builder) => ({
		messageSubmit: builder.mutation({
			query: (data: object) => ({
				url: 'orderMessages',
				body: data,
				method: 'POST',
			}),
		}),
	}),
});

export const {useMessageSubmitMutation} = orderMessagesApi;
